const toDate = (property: any) => property && isFunction(property.toDate) ? property.toDate() : property;
export { toDate };

const isFunction = (fn: any) => typeof fn === "function";
export { isFunction };

